import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { ImageList, ImageListItem } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';

import { getGigOwner, sortMilestones } from 'utils/helpers';
import { openModal } from 'features/utilsSlice';
import Milestone from './Milestone';
import MilestoneDialog from './MilestoneDialog';
import MilestoneListView from './MilestoneListView';
import AnimateList from 'components/animations/AnimateList';
import AnimateListItem from 'components/animations/AnimateListItem';
import styles from 'styles/components/milestones/Milestones.module.scss';

const alertStyle = { width: 'auto', margin: '5px 15px 20px' };

const MilestoneList = ({ gig, newStyles = {}, isPreview = false }) => {
  const [selectedMilestoneId, setSelectedMilestoneId] = useState();
  const currentUser = useSelector(state => state.auth.currentUser);
  const gigOwner = getGigOwner(currentUser, gig.user_id);
  const milestones = gig.milestones;
  const selectedMilestone = milestones.find(m => m.id === selectedMilestoneId);
  const milestonesByNetworks = [...milestones].sort((a, b) => a.network.id - b.network.id);

  const dispatch = useDispatch();
  const router = useRouter();
  const { query } = router;

  useEffect(() => {
    if (!query?.milestoneId) return;

    dispatch(openModal({ name: 'Milestone' }));
    setSelectedMilestoneId(+query.milestoneId);
  }, [dispatch, query?.milestoneId]);

  return (
    <div
      className={clsx(styles.milestones, {
        [styles.borderBottom]: milestones?.length > 0 && gig.accepted_at,
        [styles.noMilestones]: milestones?.length === 0,
      })}
    >
      <div className={styles.heading} style={newStyles}>
        {milestones.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h3>ToDos</h3>

            <span style={{ color: '#323643', fontSize: 13 }}>
              {gig.status === 'completed'
                ? `All ToDo's are completed`
                : `Click each ToDo to ${
                    gigOwner ? 'see the details' : 'find what to post and when'
                  }`}
            </span>
          </div>
        )}
      </div>

      {milestones.length === 0 ? (
        <div>
          {gigOwner ? (
            <Alert severity="info" style={alertStyle}>
              Please add some milestones
            </Alert>
          ) : (
            <Alert severity="info" style={alertStyle}>
              No scheduled milestones
            </Alert>
          )}
        </div>
      ) : (
        <AnimateList>
          <AnimateListItem>
            {sortMilestones(milestonesByNetworks).map(milestone => (
              <Milestone
                setSelectedMilestoneId={setSelectedMilestoneId}
                milestone={milestone}
                key={milestone.id}
                gig={gig}
                gigUserId={gig.user_id}
                gigStatus={gig.status}
                isPreview={isPreview}
              />
            ))}
          </AnimateListItem>
        </AnimateList>
      )}

      {/* <AnimateList key={milestones[0]?.id}>
           <ImageList className={styles.list}>
             {milestonesByNetworks.map(milestone => (
               <AnimateListItem key={milestone.id} style={width}>
                 <ImageListItem>
                   <MilestoneListView
                     setSelectedMilestoneId={setSelectedMilestoneId}
                     milestone={milestone}
                   />
                 </ImageListItem>
               </AnimateListItem>
             ))}
           </ImageList>
         </AnimateList> */}

      <MilestoneDialog gig={gig} milestone={selectedMilestone} />
    </div>
  );
};

export default MilestoneList;
